var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubble-area"},[_c('div',{staticClass:"bubble-box to-top"},[_c('div',{staticClass:"bubble-box-item",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"el-icon el-icon-top"}),_c('div',{staticClass:"bubble-item-title"},[_vm._v("回顶部")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }